import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-no-data",
  "use": "foquz-icon-no-data-usage",
  "viewBox": "0 0 49 36",
  "content": "<symbol viewBox=\"0 0 49 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-no-data\"><path d=\"M1 0v35h48M6 30h39V5l-8 7-8-3-8 9-9-3-6 6v9z\" stroke=\"#CFD8DC\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol